

export enum TimeReportGroupBy {
    PROJECT     = 'project',
    USER        = 'user',
    DATE        = 'data'
}

export enum TimeReportType {
    REPORTED                = 'reported',
    REPORTED_GUESSTIMATES   = 'reported-guesstimates',
}


export enum TimeReportIsBillableFilter {
    ALL           = 0,
    BILLABLE      = 1,
    NOT_BILLABLE  = 2
}
